import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { List, Map, fromJS } from 'immutable';
import { getFormValues, isValid, reset } from 'redux-form';

import * as tagActions from 'modules/tag';
import * as targetActions from 'modules/target';
import * as currentStatusActions from 'modules/currentStatus';
import * as validFunc from 'libs/validation';

import { Icon } from 'semantic-ui-react';

import { TargetDetail, TargetDetailMulti } from 'components';

class CtTargetDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingTargetExam: false,
      isLoadingMergeDetail: false,
      isLoadingEdu: false,
      isClicked: false,
      errorMessage: '',
      searchText: ''
    };

    this.onMoveScroll = this.onMoveScroll.bind(this);
  }

  componentDidMount() {
    this.onGetTargetExamList(true);
    this.onGetEduHistory(true);
  }

  componentDidUpdate(prevProps, prevState) {
    // 엔터 입력시 저장 처리
    const { CurrentStatusActions, isEditSubmit } = this.props;
    if (isEditSubmit) {
      CurrentStatusActions.triggerEnter({ bool: false });

      this.onEditSave();
    }

    const { targetExam, targetNoArray, isAllCheckTarget } = this.props;
    if (
      // 감염 PC가 변경되었을때
      (targetExam.get('needReload') && !this.state.isLoadingTargetExam) ||
      // 선택한 대상자가 변경되었을 때
      targetNoArray !== prevProps.targetNoArray
    ) {
      this.onGetTargetExamList(true);
    }

    if (
      // 선택한 대상자가 변경되었을 때
      targetNoArray !== prevProps.targetNoArray ||
      // 모든 대상자 선택시
      isAllCheckTarget !== prevProps.isAllCheckTarget
    ) {
      this.onGetMergeDetail(true);
    }

    if (
      // 교육이력이 변경되었을때
      (targetExam.get('needReload') && !this.state.isLoadingEdu) ||
      // 선택한 대상자가 변경되었을 때
      targetNoArray !== prevProps.targetNoArray
    ) {
      this.onGetEduHistory(true);
    }
  }

  // 훈련 이력 조회
  onGetTargetExamList = async refresh => {
    const { TargetActions, targetExam, targetNoArray } = this.props;

    if (targetNoArray.size === 1) {
      if (refresh || targetExam.get('totalPages') > targetExam.get('page')) {
        try {
          if (!!!this.state.isLoadingTargetExam) {
            this.setState({ isLoadingTargetExam: true });

            const offsetValue = refresh ? 0 : targetExam.getIn(['param', 'limit']) * targetExam.get('page');

            const params = {
              targetNo: targetNoArray.get(0),
              filter: JSON.stringify(targetExam.getIn(['param', 'filter'])),
              sort: JSON.stringify(targetExam.getIn(['param', 'sort'])),
              offset: offsetValue,
              limit: targetExam.getIn(['param', 'limit']),
              refresh: !!refresh
            };

            await TargetActions.getTargetExamList(params);
            this.setState({ isLoadingTargetExam: false });
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 교육 이력 조회
  onGetEduHistory = async refresh => {
    const { TargetActions, eduList, targetNoArray } = this.props;
    if (targetNoArray.size === 1) {
      if (refresh || eduList.get('totalPages') > eduList.get('page')) {
        try {
          if (!!!this.state.isLoadingEdu) {
            this.setState({ isLoadingEdu: true });

            const offsetValue = refresh ? 0 : eduList.getIn(['param', 'limit']) * eduList.get('page');

            const param = {
              targetNo: targetNoArray.get(0),
              filter: JSON.stringify(eduList.getIn(['param', 'filter'])),
              sort: JSON.stringify(eduList.getIn(['param', 'sort'])),
              offset: offsetValue,
              limit: eduList.getIn(['param', 'limit']),
              refresh: !!refresh
            };

            await TargetActions.getEduHistory(param);
            this.setState({ isLoadingEdu: false });
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 대상자 다중 선택시 호출
  onGetMergeDetail = async refresh => {
    const { TargetActions, selectedTag, targetNoArray, isAllCheckTarget } = this.props;

    if (targetNoArray.size > 1) {
      try {
        if (!!!this.state.isLoadingMergeDetail) {
          this.setState({ isLoadingMergeDetail: true });

          const tagNoArray =
            (selectedTag.toJS().toString() === 'all-tag' && 'all-tag') ||
            (selectedTag.toJS().toString() === 'no-tag' && 'no-tag') ||
            JSON.stringify(selectedTag);

          const params = {
            tagNoArray: tagNoArray,
            targetNoArray: JSON.stringify(targetNoArray.toJS()),
            isAllCheck: isAllCheckTarget === 2 ? 1 : 0
          };

          await TargetActions.getMergeDetail(params);
          this.setState({ isLoadingMergeDetail: false });
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  // 수정 모드로 전환
  onActiveEditMode = (e, value, type, targetNo) => {
    e.stopPropagation();
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.clear();

    if (!!targetNo && !isNaN(targetNo)) {
      CurrentStatusActions.changeTarget({
        name: 'isEditType',
        value: type
      });

      const editData = {};
      editData['targetNo'] = targetNo;
      editData[type] = value;

      CurrentStatusActions.changeTarget({
        name: 'isEditData',
        value: Map(editData)
      });
    }
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 상세보기 보이기/숨기기
  onToggleDetailView = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.onToggleDetailView();
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formTagTargetAdd');
    ReduxFormReset('formTagTargetDelete');
    this.setState({ errorMessage: '' });

    CurrentStatusActions.changeTargetTagModal({
      tagNoArray: []
    });

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 수정상태 저장 버튼
  onEditSave = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      CurrentStatusActions,
      TargetActions,
      targetDataByTargetNo,
      isEditType,
      isEditData,
      formTargetEdit,
      formTargetEditIsValid,
      TagActions
    } = this.props;
    const targetNo = isEditData.get('targetNo');
    const target = targetDataByTargetNo.get(String(targetNo));
    const targetName = target.get('targetName');
    const tagList = target.get('tagList') ? target.get('tagList') : fromJS([0]);
    const typeName =
      (isEditType === 'targetName' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_1', defaultMessage: '이름' }))) ||
      (isEditType === 'targetEmail' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_2', defaultMessage: '이메일' }))) ||
      (isEditType === 'targetPhone' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_3', defaultMessage: '연락처' }))) ||
      (isEditType === 'targetPosition' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_4', defaultMessage: '직급' }))) ||
      (isEditType === 'targetDivision' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_5', defaultMessage: '소속' }))) ||
      (isEditType === 'targetTag' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_6', defaultMessage: '태그' }))) ||
      (isEditType === 'targetDetail' &&
        defineMessages(formatMessage({ id: 'CtTargetDetail_7', defaultMessage: '메모' })));

    if (!!targetNo && !isNaN(targetNo) && formTargetEditIsValid) {
      const params = {};
      params['targetNo'] = targetNo;
      // 태그 수정
      if (isEditType === 'targetTag') {
        // 전체 삭제시 tagNoArray를 0으로 넘겨준다.
        params['tagNoArray'] =
          formTargetEdit['targetTag'].toString() === '' ? '[0]' : JSON.stringify(formTargetEdit['targetTag']);

        // 태그 변경 여부 체크
        let changed = true;
        if (tagList.toArray().toString() === JSON.parse(params['tagNoArray']).toString()) {
          changed = false;
        }

        try {
          if (changed) {
            await TargetActions.putTagTarget(params);

            this.onToggleSnackbar(
              "'" +
              targetName +
              "'" +
              defineMessages(formatMessage({ id: 'CtTargetDetail_9', defaultMessage: '의' })) +
              ' ' +
              typeName +
              ' ' +
              defineMessages(formatMessage({ id: 'CtTargetDetail_10', defaultMessage: '수정' }))
            );
          }

          CurrentStatusActions.changeTarget({
            name: 'isEditType',
            value: ''
          });
          TagActions.getTag();
        } catch (e) {
          console.log(e);
        }
        // 대상자의 정보 수정
      } else {
        params[isEditType] = formTargetEdit[isEditType];

        // 대상자 정보 변경 여부 체크
        let changed = true;
        if (target.get(isEditType) === params[isEditType]) {
          changed = false;
        }

        try {
          if (changed) {
            if (isEditType === 'targetEmail' && !!await validFunc.targetEmailValidate(formTargetEdit[isEditType])) {
              return false;
            }

            await TargetActions.putTarget(params);

            this.onToggleSnackbar(
              " '" +
              targetName +
              "'" +
              defineMessages(formatMessage({ id: 'CtTargetDetail_9', defaultMessage: '의' })) +
              ' ' +
              typeName +
              ' ' +
              defineMessages(formatMessage({ id: 'CtTargetDetail_10', defaultMessage: '수정' }))
            );
          }

          CurrentStatusActions.changeTarget({
            name: 'isEditType',
            value: ''
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 수정상태 취소 버튼
  onEditCancel = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.clear();
  };

  // 태그 추가
  onAddTagTarget = async () => {
    this.setState({ isClicked: true });
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const {
        TagActions,
        TargetActions,
        CurrentStatusActions,
        formTagTargetAdd,
        targetNoArray,
        isAllCheckTarget,
        selectedTag
      } = this.props;
      let errorMessage = '';

      if (Array.isArray(formTagTargetAdd.tagNoArray) && formTagTargetAdd.tagNoArray.length > 0) {
        const params = {};
        // 추가되는 태그 번호
        params['tagNoArray'] = JSON.stringify(formTagTargetAdd.tagNoArray);

        if (isAllCheckTarget === 2) {
          params['isAllCheck'] = 1;
          // 선택한 태그 번호
          params['checkTagNoArray'] = JSON.stringify(selectedTag);
        } else {
          params['isAllCheck'] = 0;
          params['targetNoArray'] = JSON.stringify(targetNoArray);
        }

        await TargetActions.postTagTarget(params);

        TagActions.getTag();

        this.onToggleSnackbar(
          defineMessages(formatMessage({ id: 'CtTargetDetail_11', defaultMessage: '태그 일괄 등록' }))
        );

        CurrentStatusActions.onToggleModal({ viewType: '' });
        CurrentStatusActions.changeTarget({
          name: 'isEditType',
          value: ''
        });
      } else {
        errorMessage = defineMessages(formatMessage({ id: 'vali_5', defaultMessage: '값을 입력하세요.' }));
      }

      this.setState({ errorMessage });
      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
      this.setState({ isClicked: false });
    }
  };

  // 태그 삭제
  onDeleteTagTarget = async () => {
    this.setState({ isClicked: true });

    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const {
        TagActions,
        TargetActions,
        CurrentStatusActions,
        formTagTargetDelete,
        targetNoArray,
        isAllCheckTarget,
        selectedTag
      } = this.props;
      let errorMessage = '';

      if (Array.isArray(formTagTargetDelete.tagNoArray) && formTagTargetDelete.tagNoArray.length > 0) {
        const params = {};
        // 추가되는 태그 번호
        params['tagNoArray'] = JSON.stringify(formTagTargetDelete.tagNoArray);

        if (isAllCheckTarget === 2) {
          params['isAllCheck'] = 1;
          // 선택한 태그 번호
          params['checkTagNoArray'] = JSON.stringify(selectedTag);
        } else {
          params['isAllCheck'] = 0;
          params['targetNoArray'] = JSON.stringify(targetNoArray);
        }

        await TargetActions.deleteTagTarget(params);

        TagActions.getTag();

        this.onToggleSnackbar(
          defineMessages(formatMessage({ id: 'CtTargetDetail_12', defaultMessage: '태그 일괄 삭제' }))
        );

        CurrentStatusActions.onToggleModal({ viewType: '' });
        CurrentStatusActions.changeTarget({
          name: 'isEditType',
          value: ''
        });
      } else {
        errorMessage = defineMessages(formatMessage({ id: 'vali_5', defaultMessage: '값을 입력하세요.' }));
      }

      this.setState({ errorMessage });
      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
      this.setState({ isClicked: false });
    }
  };

  // 아이콘을 통한 스크롤 이동 처리
  onMoveScroll = id => {
    this.scroll.scrollTop(this[id].offsetTop - 15);
  };

  // 스크롤 ref 등록
  onRefRegister = (key, refObject) => {
    if (!!refObject) {
      this[key] = refObject;
    }
  };

  // [훈련 이력] 상세 보기
  onToggleTargetExam = examNo => {
    const { TargetActions, targetExam } = this.props;
    const array = targetExam.get('isOpen');
    const index = array.indexOf(examNo);

    // (삭제) 상세 닫기
    if (index !== -1) {
      TargetActions.changeTargetExam({ name: 'isOpen', value: array.splice(index, 1) });
      // (추가) 상세 열기
    } else {
      TargetActions.changeTargetExam({ name: 'isOpen', value: array.push(examNo) });
    }
  };

  // (단일 대상자) 상세보기에서 태그 수정
  handleChangeTag = (e, { value }) => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.changeTargetTag({
      tagNames: value
    });

    this.setState({
      searchText: ''
    });
  };

  // (다중 대상자) 모달에서 태그 수정
  handleChangeModalTag = (e, { value }) => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    if (value.length === 0) {
      this.setState({
        errorMessage: defineMessages(formatMessage({ id: 'vali_5', defaultMessage: '값을 입력하세요.' }))
      });
    } else if (this.state.errorMessage !== '') {
      this.setState({
        errorMessage: ''
      });
    }

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.changeTargetTagModal({
      tagNoArray: value
    });

    this.setState({
      searchText: ''
    });
  };


  // 태그 검색창에 글자 입력 시
  handleSearchChange = e => {
    this.setState({
      searchText: e.target.value
    });
  }

  // 태그 검색 영역 이외의 영역 클릭 시
  handleBlur = e => {
    this.setState({
      searchText: ''
    });
  }

  render() {
    const {
      onActiveEditMode,
      onToggleSnackbar,
      onEditSave,
      onEditCancel,
      onToggleModal,
      onAddTagTarget,
      onDeleteTagTarget,
      onToggleDetailView,
      handleChangeTag,
      handleChangeModalTag,
      onMoveScroll,
      onRefRegister,
      onToggleTargetExam,
      // 훈련이력 조회
      onGetTargetExamList,
      // 교육이력 조회
      onGetEduHistory
    } = this;
    const {
      targetNoArray,
      tagDataByTagNo,
      targetDataByTargetNo,
      tagTargetArray,
      isEditType,
      isEditData,
      isSnackbar,
      isModal,
      // 훈련 이력
      targetExam,
      // 대상자 다중 선택시 정보
      mergeDetail,
      // 교육 이력
      eduList
    } = this.props;
    // 대상자 전체 선택 처리
    const { totalTarget, isAllCheckTarget } = this.props;

    // 다중 선택된 대상자 상세정보
    if (targetNoArray.size > 1) {
      return (
        <TargetDetailMulti
          mergeDetail={mergeDetail}
          targetNoArray={targetNoArray}
          tagTargetArray={tagTargetArray}
          tagDataByTagNo={tagDataByTagNo}
          targetDataByTargetNo={targetDataByTargetNo}
          // 모든 대상자 선택처리
          totalTarget={totalTarget}
          isAllCheckTarget={isAllCheckTarget}
          //
          isEditType={isEditType}
          isEditData={isEditData}
          isSnackbar={isSnackbar}
          isModal={isModal}
          isClicked={this.state.isClicked}
          errorMessage={this.state.errorMessage}
          isLoadingMergeDetail={this.state.isLoadingMergeDetail}
          // function
          onToggleSnackbar={onToggleSnackbar}
          onToggleDetailView={onToggleDetailView}
          onToggleModal={onToggleModal}
          onAddTagTarget={onAddTagTarget}
          onDeleteTagTarget={onDeleteTagTarget}
          handleChangeModalTag={handleChangeModalTag}
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
          handleSearchChange={this.handleSearchChange}
          handleBlur={this.handleBlur}
          searchText={this.state.searchText}
        />
      );
      // 단일 대상자 상세 정보
    } else {
      return (
        <TargetDetail
          targetNoArray={targetNoArray}
          tagDataByTagNo={tagDataByTagNo}
          targetDataByTargetNo={targetDataByTargetNo}
          isEditType={isEditType}
          isEditData={isEditData}
          isSnackbar={isSnackbar}
          // 훈련 이력 보기/닫기
          isOpenTargetExam={targetExam.get('isOpen')}
          // 훈련 이력 보기/닫기 function
          onToggleTargetExam={onToggleTargetExam}
          isLoadingTargetExam={this.state.isLoadingTargetExam}
          targetExam={targetExam}
          // 교육 이력
          isLoadingEdu={this.state.isLoadingEdu}
          eduList={eduList}
          // function
          onActiveEditMode={onActiveEditMode}
          onToggleSnackbar={onToggleSnackbar}
          onToggleDetailView={onToggleDetailView}
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          handleChangeTag={handleChangeTag}
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
          // 훈련이력 조회
          onGetTargetExamList={onGetTargetExamList}
          // 교육이력 조회
          onGetEduHistory={onGetEduHistory}
          handleSearchChange={this.handleSearchChange}
          handleBlur={this.handleBlur}
          searchText={this.state.searchText}
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  isEditSubmit: state.currentStatus.get('isEditSubmit'),
  isSnackbar: state.currentStatus.get('isSnackbar'),
  isModal: state.currentStatus.get('isModal'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  isEditType: state.currentStatus.getIn(['target', 'isEditType']),
  isEditData: state.currentStatus.getIn(['target', 'isEditData']),
  isAllCheckTarget: state.currentStatus.getIn(['target', 'selectTarget', 'isAllCheckTarget']),
  targetNoArray: state.currentStatus.getIn(['target', 'selectTarget', 'targetNoArray']),
  tagTargetArray: state.currentStatus.getIn(['target', 'tagTarget']),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  totalTarget: state.target.get('totalTarget'),
  mergeDetail: state.target.get('mergeDetail'),
  targetDataByTargetNo: state.target.get('targetDataByTargetNo'),
  targetExam: state.target.get('targetExam'),
  eduList: state.target.get('eduList'),
  formTagTargetAdd: getFormValues('formTagTargetAdd')(state),
  formTagTargetDelete: getFormValues('formTagTargetDelete')(state),
  formTargetEdit: getFormValues('formTargetEdit')(state),
  formTargetEditIsValid: isValid('formTargetEdit')(state)
});

const mapDispatchToProps = dispatch => ({
  TagActions: bindActionCreators(tagActions, dispatch),
  TargetActions: bindActionCreators(targetActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtTargetDetail));



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTargetDetail.js